export const CUSTOMER_PROFILE_KEY = 'customerProfile'

export const customerProfileQueryKeys = {
  all: [CUSTOMER_PROFILE_KEY] as const,
  currentCustomer: () => [...customerProfileQueryKeys.all, 'currentCustomer'] as const,
  byCustomerId: (customerId: number | null) => [...customerProfileQueryKeys.all, 'customer', customerId] as const,
}
